
'use client';

import { Calendar, FileText, CreditCard, CheckCircle2 } from "lucide-react";
import React from "react";

const steps = [
    { icon: Calendar, text: "Apply Now" },
    { icon: FileText, text: "Share your Documents" },
    { icon: CreditCard, text: "Pay Online" },
    { icon: CheckCircle2, text: "Get Your Visa" },
];

export function ApplicationSteps() {
    return (
        <div className="bg-amber-100 p-8 rounded-lg">
            <h2 className="text-2xl font-bold text-center mb-8">Applying for UAE Tourist Visa through us is this simple</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-center">
                {steps.map((step, index) => (
                    <div key={index} className="relative flex flex-col items-center">
                        <div className="mb-4">
                            <step.icon size={40} className="text-neutral-700" />
                        </div>
                        <p className="font-semibold">{step.text}</p>
                        {index < steps.length - 1 && (
                             <div className="hidden md:block absolute h-full w-px bg-neutral-300 right-0 top-0 transform translate-x-1/2"></div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
